<template>

      <div class="trigger" v-tooltip.right-start="updatedNote" v-clipboard:copy="note" v-clipboard:success="onCopy">
          <i class="fa fa-commenting" aria-hidden="true"></i>
      </div>

</template>

<script>
  export default {
    props: {
      note: {
        type: String,
        default: ''
      }
    },
    computed: {
       updatedNote(){
          return `<strong style="color: rgb(68, 127, 255);">Customer Note:</strong> <br/> ${this.note}`
       }
    },
    methods: {
      onCopy(){
         this.$toasted.show("Note added to clipboard", {
            type: "info",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 1000,
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
   $backgroundForTrigger: rgb(167, 50, 245);
   .trigger{
     position: absolute;
     left: -35px;
     bottom: 35px;
     background-color: $backgroundForTrigger;
     width: 30px;
     height: 30px;
     line-height: 30px;
     text-align: center;
     text-align: center;
     color: #fff;
     border-radius: 3px 0 0 3px;
     cursor: pointer;
     transform: translateZ(-10px);
     transition: all 300ms ease;
     border-radius: 50%;
      animation: bounce 600ms infinite alternate;
      -webkit-animation: bounce 600ms infinite alternate;
     &::after{
       position: absolute;
       content: "";
       width: 100px;
       height: 2px;
       top:50%;
       right: -100px;
       background-color:$backgroundForTrigger;
       transform: translate(0, -1px);
     }
     &::before{
       content: "Note by customer";
       position: absolute;
       top: 0;
       left:-145px;
       background-color: $backgroundForTrigger;
       width: 140px;
       visibility: hidden;
       opacity: 0;
       transition: all 300ms ease;
     }
     &:hover{
       left: -40px;
       animation-play-state: paused;
       &::before{
         visibility: visible;
         opacity:1;
       }
     }
   }

@keyframes bounce {
  from {
    transform: translate3d(0px, 0, -5px);
  }
  to {
    transform: translate3d(-5px, 0, -5px);
  }
}
@-webkit-keyframes bounce {
  from {
    transform: translate3d(0px, 0, -5px);
  }
  to {
    transform: translate3d(-5px, 0, -5px);
  }
}
</style>